import React from "react";
import { useNavigate } from "react-router-dom";

const NotFound = () => {
  const navigate = useNavigate();
  return (
    <div style={{ textAlign: "center", padding: "50px" }}>
      <h1>404 Not Found</h1>
      <p>The page you're looking for doesn't exist.</p>
      {/* Optionally add a link back to home */}
      <button onClick={() => navigate("/")}>Go back to Home</button>
    </div>
  );
};

export default NotFound;


